// src/components/Header.js
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom'; // Import Link
import './Header.css';
import { useAuth } from '@workos-inc/authkit-react';
import ThemeToggle from './ThemeToggle';
import { getBranding } from '../scripts/branding';

const WaffleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12"></line>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

const Header = ({ onToggleSidebar, onLogoutClick }) => {
  const { user } = useAuth();
  const [branding, setBranding] = useState({});
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setBranding(getBranding());
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    signOut();
  };

  const getInitials = () => {
    if (user?.firstName && user?.lastName) return `${user.firstName[0]}${user.lastName[0]}`;
    if (user?.firstName) return user.firstName[0];
    if (user?.email) return user.email[0];
    return 'U';
  };

  const welcomeMessage = user ? `Welcome, ${user.firstName || user.email}` : 'Welcome';

  const title = branding.toolName ? `${branding.toolName} by ${branding.shortCompanyName}` : '';

  return (
    <header className="app-header">
      <div className="header-left">
        <button className="sidebar-toggle" onClick={onToggleSidebar} aria-label="Toggle sidebar">
          <WaffleIcon />
        </button>
        <div className="header-title">
          <span className="logo-text">{title}</span>
        </div>
      </div>
      <div className="header-controls">
        <ThemeToggle />
        <div className="profile-menu" ref={dropdownRef}>
          <div
            className="profile-icon"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            aria-expanded={isDropdownOpen}
            role="button"
            tabIndex="0"
          >
            {getInitials()}
          </div>
          <div className={`profile-dropdown ${isDropdownOpen ? 'active' : ''}`}>
            <div className="dropdown-header">
              <p>{welcomeMessage}</p>
            </div>
            <ul className="dropdown-menu">
              <li className="dropdown-menu-item">
                <Link to="/profile"><span>Profile</span></Link>
              </li>
              <li className="dropdown-menu-item">
                <button onClick={onLogoutClick}><span>Logout</span></button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
